// Framework
import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

// Platform specific
import { HomeComponent } from './home.component'
import { HomeStartComponent } from './views/start/start.component'
import { HomeView2Component } from './views/view2/view2.component'
import { FileNotFoundComponent } from '../_404/404.component'
import { AboutComponent } from './about/about.component'
// import { authGuard, a, b, c } from '@engineering11/auth-web'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: AboutComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
      },
      {
        path: '**',
        component: FileNotFoundComponent,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
